{
  "title": "المستخدمين",
  "description": "مستخدمو لوحة التحكم والعمليات",
  "actions": {
    "add": "إضافة مستخدم"
  },
  "columns": {
    "name": "الاسم",
    "username": "اسم المستخدم",
    "group": "المجموعة",
    "branches": "الفروع",
    "status": "الحالة",
    "lastLogin": "آخر تسجيل دخول"
  },
  "neverLoggedIn": "لم يسجل الدخول مطلقا",
  "list": {
    "ariaLabel": "المستخدمون",
    "searchPlaceholder": "البحث بالاسم أو اسم المستخدم"
  },
  "rowActions": {
    "edit": "تعديل",
    "resetPassword": "إعادة تعيين كلمة المرور",
    "activate": "تفعيل",
    "deactivate": "تعطيل",
    "delete": "حذف"
  },
  "drawer": {
    "createTitle": "إضافة مستخدم",
    "editTitle": "تعديل المستخدم",
    "lookup": {
      "label": "البحث عن موظف باسم المستخدم",
      "placeholder": "اسم المستخدم",
      "search": "بحث",
      "searching": "جاري البحث...",
      "notFound": "لم يتم العثور على موظف بهذا الاسم. يمكنك إنشاء موظف جديد بهذا الاسم.",
      "alreadyUser": "هذا الموظف لديه مستخدم بالفعل في نظام المحروقات.",
      "found": "تم العثور على: {{name}}",
      "useNew": "استخدام موظف جديد بدلا من ذلك"
    },
    "fields": {
      "username": "اسم المستخدم",
      "nameAr": "الاسم بالعربية",
      "nameEn": "الاسم بالإنجليزية",
      "email": "البريد الإلكتروني",
      "phone": "رقم الهاتف",
      "group": "المجموعة",
      "branches": "الفروع"
    },
    "submit": "حفظ",
    "cancel": "إلغاء",
    "discard": {
      "title": "تجاهل التغييرات؟",
      "description": "لن يتم حفظ ما أدخلته على هذا المستخدم.",
      "confirmLabel": "تجاهل",
      "cancelLabel": "متابعة التعديل"
    },
    "created": "تم إنشاء المستخدم بنجاح",
    "updated": "تم تحديث المستخدم بنجاح"
  },
  "statusConfirm": {
    "activateTitle": "تفعيل {{name}}؟",
    "activateDescription": "سيتمكن هذا المستخدم من تسجيل الدخول مجددا.",
    "deactivateTitle": "تعطيل {{name}}؟",
    "deactivateDescription": "لن يتمكن هذا المستخدم من تسجيل الدخول حتى تتم إعادة تفعيله.",
    "confirmActivate": "تفعيل",
    "confirmDeactivate": "تعطيل"
  },
  "deleteConfirm": {
    "title": "حذف {{name}}؟",
    "description": "سيتم حذف هذا المستخدم نهائيا. هذا الإجراء لا يمكن التراجع عنه.",
    "confirm": "حذف"
  },
  "resetConfirm": {
    "title": "إعادة تعيين كلمة مرور {{name}}؟",
    "description": "سيتم إلغاء كلمة المرور الحالية وإنشاء رابط جديد لتعيين كلمة مرور.",
    "confirm": "إعادة تعيين"
  },
  "passwordLink": {
    "resetTitle": "تمت إعادة تعيين كلمة المرور",
    "createTitle": "تم إنشاء المستخدم",
    "emailedDescription": "تم إرسال رابط تعيين كلمة المرور إلى البريد الإلكتروني للموظف.",
    "linkDescription": "انسخ هذا الرابط لمرة واحدة وشاركه مع الموظف:",
    "copy": "نسخ الرابط",
    "copied": "تم النسخ",
    "close": "إغلاق"
  },
  "toasts": {
    "statusChanged": "تم تغيير حالة المستخدم بنجاح",
    "deleted": "تم حذف المستخدم بنجاح",
    "passwordReset": "تمت إعادة تعيين كلمة المرور"
  },
  "platformAccess": {
    "operator": "العمليات (Operator)",
    "dashboard": "لوحة التحكم (Dashboard)"
  }
}
